import React from 'react';
import { Capacitor } from '@capacitor/core';

const UpdateRequiredScreen = () => {
  // Uzupełnij swoimi prawdziwymi linkami do sklepu
      const APP_STORE_LINK = "https://apps.apple.com/pl/app/matematly-matura-z-matematyki/id6754283687?l=pl"; // Uzupełnij swoim linkiem
    const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=matematly.pl"; // Uzupełnij swoim linkiem

  const handleUpdateClick = () => {
    const platform = Capacitor.getPlatform();
    if (platform === 'ios') {
      // Otwiera link w zewnętrznej przeglądarce (App Store)
      window.open(APP_STORE_LINK, '_system');
    } else if (platform === 'android') {
      window.open(GOOGLE_PLAY_LINK, '_system');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-sm">
        <h2 className="text-2xl font-bold font-apotek uppercase text-[#233855] mb-4">
          Wymagana Aktualizacja
        </h2>
        <p className="text-gray-700 mb-6">
          Dostępna jest nowa, lepsza wersja aplikacji. Aby kontynuować, pobierz
          aktualizację ze sklepu.
        </p>
        <button 
          onClick={handleUpdateClick}
          className="flex w-full justify-center rounded-lg bg-[#233855] px-4 py-3 text-sm font-apotek uppercase tracking-widest text-slate-100 shadow-lg hover:bg-[#345081]"
        >
          Aktualizuj teraz
        </button>
      </div>
    </div>
  );
};

export default UpdateRequiredScreen;